(() => {
   
  function handleClassChange(mutationsList) {
    for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            const target = mutation.target;
            if (target.classList.contains('active')) {
              BSS_B2B.cart.fixer(BSS_B2B.shopData,0,0)
              setTimeout(() => {
                BSS_B2B.cart.fixer(BSS_B2B.shopData,0,0)
              }, 1500)
            }
        }
    }
  }

  const observer = new MutationObserver(handleClassChange);
  const targetElement = document.querySelector('.quick-cart__wrapper');
  if (targetElement) {
      observer.observe(targetElement, { attributes: true });
  }
  
  const isCollectionPage = window.location.pathname.includes('/collections/') || window.location.pathname.includes('/search');
  if(isCollectionPage) {
    handleFilterCollection();
  }
  function handleFilterCollection(){
    function handleClassChange(mutationsList) {
      for (const mutation of mutationsList) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
              const target = mutation.target;
              if (!target.classList.contains('is-active')) {
                BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData, 0, 0)
              }
          }
      }
    }
  
    const observer = new MutationObserver(handleClassChange);
    const targetElement = document.querySelector('.collection__loading, .search__loading');
    if (targetElement) {
        observer.observe(targetElement, { attributes: true });
    } else {
        console.error(`The element with class 'collection__loading' was not found`);
    }
  }

  const isCartPage = window.location.pathname === '/cart';
  if(isCartPage) {
    document.addEventListener("click", e => {
      if(e.target.matches(BSS_B2B.cart.buttonChangeQuantity) || e.target.matches(BSS_B2B.cart.removeButtons)) {
          setTimeout(() => {
              BSS_B2B.cart.fixer(BSS_B2B.shopData,0,0);
              BSS_B2B.handleCartCheckoutBtn(BSS_B2B.shopData);
          }, 2000)
      }
    }, true)
    document.addEventListener("change", e => {
      if(e.target.matches(BSS_B2B.cart.inputQuantityElement)) {
          setTimeout(() => {
              BSS_B2B.cart.fixer(BSS_B2B.shopData,0,0);
              BSS_B2B.handleCartCheckoutBtn(BSS_B2B.shopData);
          }, 2000)
      }
    }, true)

    document.addEventListener("DOMContentLoaded", function () {
        let quickCart = document.querySelector(".quick-cart__container");
        if (quickCart) {
            quickCart.remove();
        }
    });
  }

// function handleButtonClick(e) {
//   e.preventDefault();
//   const button = e.currentTarget;
//   const oldText = button.textContent;
//   button.style.pointerEvents = 'none';
//   button.style.opacity = '0.6';
//   button.textContent = "Loading ...";

//   setTimeout(() => {
//     button.style.pointerEvents = 'auto';
//     button.style.opacity = '1';
//     button.textContent = oldText;
//   }, 2000);
// }

// setTimeout(() => {
//   document.querySelectorAll('button[name="checkout"]').forEach(button => {
//     button.addEventListener('click', handleButtonClick);
//     button.addEventListener('dblclick', handleButtonClick);
//   });
// }, 500);

  BSS_B2B.customTriggerCheckoutBtn = function(){
    window.location.href = "/checkout";
  }
})()